"use client";

/** ボタン。決定は primary、取り消しと副操作は既定、削除は danger の見た目を取る */
export default function Button({
  children,
  onClick,
  type = "button",
  variant = "default",
  disabled,
  inline,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "default" | "primary" | "danger";
  disabled?: boolean;
  inline?: boolean;
}) {
  const classes = ["button"];
  if (variant === "primary") classes.push("button-primary");
  if (variant === "danger") classes.push("button-danger");
  if (inline) classes.push("button-inline");

  return (
    <button className={classes.join(" ")} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
